import { render, staticRenderFns } from "./GroupBoard.vue?vue&type=template&id=1bc34652&scoped=true&"
import script from "./GroupBoard.vue?vue&type=script&lang=js&"
export * from "./GroupBoard.vue?vue&type=script&lang=js&"
import style0 from "./GroupBoard.vue?vue&type=style&index=0&id=1bc34652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc34652",
  null
  
)

export default component.exports